import { Link } from "@tanstack/react-router";
import { RELATED_READING } from "@/lib/related-reading";
import { POST_BY_SLUG } from "@/lib/blog";
import { SERVICE_BY_SLUG } from "@/lib/services";

export function RelatedReading({ slug }: { slug: string }) {
  const entry = RELATED_READING[slug];
  if (!entry) return null;
  const posts = entry.posts.map((s) => POST_BY_SLUG[s]).filter(Boolean).slice(0, 3);
  const services = entry.services.map((s) => SERVICE_BY_SLUG[s]).filter(Boolean).slice(0, 3);
  if (!posts.length && !services.length) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 pb-12">
      <h2 className="text-2xl font-extrabold text-secondary mb-4">Related reading</h2>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((p) => (
          <Link key={p.slug} to={`/${p.slug}` as any} className="rounded-lg border border-border bg-card p-4 hover:border-primary transition-colors">
            <div className="font-bold text-secondary">{p.title}</div>
          </Link>
        ))}
      </div>
      {services.length > 0 && (
        <p className="mt-4 text-sm text-muted-foreground">
          Related services:{" "}
          {services.map((s, i) => (
            <span key={s.slug}>
              {i > 0 && " · "}
              <Link to={`/${s.slug}` as any} className="font-semibold text-primary hover:underline">
                {s.name} in Phoenix
              </Link>
            </span>
          ))}
        </p>
      )}
    </section>
  );
}
